import React, { useState, useEffect, useRef } from 'react';
import styles from './MobileMenu.module.css';
import Langs from '../../app/lang/langs';

export function MobileMenu({
    menuItems,
    urlParams,
    email,
    username,
    roleType,
    getUsernameInitials,
    onSelectMenu,
    onLogout
}) {
    const [visible, setVisible] = useState(false)
    const [cardsReady, setCardsReady] = useState(false)
    const panelRef = useRef(null)

    useEffect(() => {
        if (visible) {
            const timer = setTimeout(() => setCardsReady(true), 80)
            return () => clearTimeout(timer)
        } else {
            setCardsReady(false)
        }
    }, [visible])

    // Close on back button
    useEffect(() => {
        const handleBack = (e) => {
            if (visible) {
                e.preventDefault()
                setVisible(false)
            }
        }
        window.addEventListener('popstate', handleBack)
        return () => window.removeEventListener('popstate', handleBack)
    }, [visible])

    function handleSelect(value) {
        setVisible(false)
        setTimeout(() => onSelectMenu(value), 300)
    }

    const visibleItems = menuItems.filter(item => item.visible)

    return (
        <>
            {/* FAB toggle button */}
            <button
                className={`${styles.fab} ${visible ? styles.fabOpen : ''}`}
                onClick={() => setVisible(!visible)}
                aria-label={visible ? "Close Menu" : "Open Menu"}>
                <span className={styles.fabIcon}>
                    {visible ? '+' : <i className="pi pi-th-large" />}
                </span>
            </button>

            {/* Backdrop overlay */}
            <div
                className={`${styles.overlay} ${visible ? styles.overlayVisible : ''}`}
                onClick={() => setVisible(false)}
            />

            {/* Bottom sheet panel */}
            <div
                ref={panelRef}
                className={`${styles.panel} ${visible ? styles.panelVisible : ''}`}>

                {/* Drag handle */}
                <div className={styles.handle} />

                {/* Profile header */}
                <div className={styles.profileHeader}>
                    <button className={styles.avatar}>
                        {getUsernameInitials()}
                    </button>
                    <div className={styles.profileInfo}>
                        <span className={styles.profileName}>
                            {username && username !== "null" ? username : email}
                        </span>
                        <span className={styles.profileRole}>{roleType}</span>
                    </div>
                    <button
                        className={styles.logoutBtn}
                        onClick={() => {
                            setVisible(false)
                            onLogout()
                        }}
                        aria-label="Logout">
                        <i className="pi pi-sign-out" />
                    </button>
                </div>

                {/* Menu items grid */}
                <div className={styles.grid}>
                    {visibleItems.map((item, idx) => {
                        const isActive = urlParams.view && urlParams.view.toLowerCase() === item.value.toLowerCase()
                        const image = isActive ? item.imageFocus : item.image

                        return (
                            <div
                                key={"mobile_menu_" + item.value}
                                className={
                                    `${styles.card} ${cardsReady ? styles.cardVisible : ''} ${isActive ? styles.cardActive : ''}`
                                }
                                style={{
                                    transitionDelay: cardsReady ? `${idx * 40}ms` : '0ms'
                                }}
                                onClick={() => handleSelect(item.value)}>
                                <img
                                    className={styles.cardIcon}
                                    src={image}
                                    alt={item.value}
                                />
                                <span className={styles.cardLabel}>
                                    <Langs str={item.label} />
                                </span>
                            </div>
                        )
                    })}
                </div>

                {/* Safe area spacer */}
                <div className={styles.safeArea} />
            </div>
        </>
    )
}
